import Model from './Model';

export default class ToldoProyeccion extends Model {
    boot() {
        super.boot();

        this.modelName = 'toldo-proyeccion';
        this.config.customRoutes = [
            {
                name: 'data',
                type: 'get',
                url: 'data/t-proyeccion'
            },
            {
                name: 'models',
                type: 'get',
                url: 'models/t-proyeccion'
            },
            {
                name: 'update',
                type: 'patch',
                url: 'toldo-proyeccion/{id}/'
            }
        ]
    }

    data = (params) => {
        return this.withParams(params).route('data');
    };

    models = (params) => {
        return this.withParams(params).route('models');
    };

    update = (id, params) => {
        return this.withParams(params).route('update', { id });
    };
}
